﻿/**
* DevExpress Dashboard (item-widget-event-args.js)
* Version:  20.1.8
* Build date: Oct 12, 2020
* Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("devextreme/ui/widget/ui.widget");
var index_internal_1 = require("../../data/index.internal");
var ChartContext = (function () {
    function ChartContext(_dashboardItem) {
        this._dashboardItem = _dashboardItem;
    }
    ChartContext.prototype.getDashboardItemSeries = function (seriesOptions) {
        return this._dashboardItem
            .panes()
            .reduce(function (acc, pane) { return acc.concat(pane.series()); }, [])
            .filter(function (series) { return seriesOptions[index_internal_1.DashboardDataIdField] && series._getDataId() === seriesOptions[index_internal_1.DashboardDataIdField]; })[0];
    };
    return ChartContext;
}());
exports.ChartContext = ChartContext;
var GridContext = (function () {
    function GridContext(_dashboardItem) {
        this._dashboardItem = _dashboardItem;
    }
    GridContext.prototype.getDashboardItemColumn = function (columnOptions) {
        return this._dashboardItem
            .columns()
            .filter(function (column) { return columnOptions[index_internal_1.DashboardDataIdField] && column._getDataId() === columnOptions[index_internal_1.DashboardDataIdField]; })[0];
    };
    return GridContext;
}());
exports.GridContext = GridContext;
var GaugeContext = (function () {
    function GaugeContext(_dashboardItem) {
        this._dashboardItem = _dashboardItem;
    }
    GaugeContext.prototype.getDashboardItemGauge = function (gaugeOptions) {
        return this._dashboardItem
            .gauges()
            .filter(function (gauge) { return gaugeOptions[index_internal_1.DashboardDataIdField] && gauge._getDataId() === gaugeOptions[index_internal_1.DashboardDataIdField]; })[0];
    };
    return GaugeContext;
}());
exports.GaugeContext = GaugeContext;
